<template>
    <div class="">
        <span class="faux-button text-primary border border-primary rounded btn btn-outline-primary" @click="click" title="Select all">
            <i v-if="checked" class="far fa-check-square"></i>
            <i v-else class="far fa-square"></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: true
        }
    },

    mounted() {
        this.checked = this.value;
    },

    methods: {
        click() {
            this.checked = !this.checked;
            this.$emit('input', this.checked);
        }
    },

    data() {
        return {
            checked: true,
        };
    }
}
</script>

<style scoped>
.faux-button {
    padding: .05em .5em !important;
}

.faux-button:hover {
    color: White !important;
}
</style>